import { render } from "./QAndAChatItem.vue?vue&type=template&id=df6df1ba&scoped=true"
import script from "./QAndAChatItem.vue?vue&type=script&lang=js"
export * from "./QAndAChatItem.vue?vue&type=script&lang=js"

import "./QAndAChatItem.vue?vue&type=style&index=0&id=df6df1ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6df1ba"]])

export default __exports__